module.exports = __webpack_public_path__ + "assets/img_match_with_talent.9c716da6.png";